import type React from 'react';

import { LoginRouter } from 'core/auth';
import Shell from './shell';

export interface IProps {}

const AuthPages: React.FC<IProps> = () => (
  <Shell>
    <div id="form-login" className="p-t-15">
      <LoginRouter />
    </div>
  </Shell>
);

export default AuthPages;
